'use strict';

var _objectSpread = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _regeneratorRuntime = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");
var _asyncToGenerator = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/Users/jfunulab/Workspace/work/react/GroupApp-web-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
var isIp = require('is-ip');
var CancelError = /*#__PURE__*/function (_Error) {
  _inherits(CancelError, _Error);
  function CancelError() {
    var _this;
    _classCallCheck(this, CancelError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CancelError).call(this, 'Request was cancelled'));
    _this.name = 'CancelError';
    return _this;
  }
  _createClass(CancelError, [{
    key: "isCanceled",
    get: function get() {
      return true;
    }
  }]);
  return CancelError;
}(_wrapNativeSuper(Error));
var defaults = {
  timeout: 5000
};
var urls = {
  v4: ['https://ipv4.icanhazip.com/', 'https://api.ipify.org/'],
  v6: ['https://ipv6.icanhazip.com/', 'https://api6.ipify.org/']
};
var sendXhr = function sendXhr(url, options, version) {
  var xhr = new XMLHttpRequest();
  var _reject;
  var promise = new Promise(function (resolve, reject) {
    _reject = reject;
    xhr.addEventListener('error', reject, {
      once: true
    });
    xhr.addEventListener('timeout', reject, {
      once: true
    });
    xhr.addEventListener('load', function () {
      var ip = xhr.responseText.trim();
      if (!ip || !isIp[version](ip)) {
        reject();
        return;
      }
      resolve(ip);
    }, {
      once: true
    });
    xhr.open('GET', url);
    xhr.timeout = options.timeout;
    xhr.send();
  });
  promise.cancel = function () {
    xhr.abort();
    _reject(new CancelError());
  };
  return promise;
};
var queryHttps = function queryHttps(version, options) {
  var request;
  var promise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var urls_, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, url, ip;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            urls_ = [].concat.apply(urls[version], options.fallbackUrls || []);
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 4;
            _iterator = urls_[Symbol.iterator]();
          case 6:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 23;
              break;
            }
            url = _step.value;
            _context.prev = 8;
            request = sendXhr(url, options, version);
            // eslint-disable-next-line no-await-in-loop
            _context.next = 12;
            return request;
          case 12:
            ip = _context.sent;
            return _context.abrupt("return", ip);
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](8);
            if (!(_context.t0 instanceof CancelError)) {
              _context.next = 20;
              break;
            }
            throw _context.t0;
          case 20:
            _iteratorNormalCompletion = true;
            _context.next = 6;
            break;
          case 23:
            _context.next = 29;
            break;
          case 25:
            _context.prev = 25;
            _context.t1 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t1;
          case 29:
            _context.prev = 29;
            _context.prev = 30;
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          case 32:
            _context.prev = 32;
            if (!_didIteratorError) {
              _context.next = 35;
              break;
            }
            throw _iteratorError;
          case 35:
            return _context.finish(32);
          case 36:
            return _context.finish(29);
          case 37:
            throw new Error('Couldn\'t find your IP');
          case 38:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 25, 29, 37], [8, 16], [30,, 32, 36]]);
  }))();
  promise.cancel = function () {
    request.cancel();
  };
  return promise;
};
module.exports.v4 = function (options) {
  return queryHttps('v4', _objectSpread({}, defaults, options));
};
module.exports.v6 = function (options) {
  return queryHttps('v6', _objectSpread({}, defaults, options));
};